import React from 'react';
import { convertToDescriptions } from '../../../../utils/transfer/activity';
import { ActivityLogInterface } from '../../../../types/activityLog';

interface ActivityColumnProps {
  record?: ActivityLogInterface;
}

export default React.memo((props: ActivityColumnProps) => {
  return <>{convertToDescriptions(props?.record)}</>;
});
